export default {"src":"/_next/static/media/staking.01bfbeae.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};